import { render } from "./MiezzMonthChoose.vue?vue&type=template&id=90637b4c&scoped=true&ts=true"
import script from "./MiezzMonthChoose.vue?vue&type=script&lang=ts"
export * from "./MiezzMonthChoose.vue?vue&type=script&lang=ts"

import "./MiezzMonthChoose.vue?vue&type=style&index=0&id=90637b4c&lang=sass&scoped=true"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90637b4c"]])

export default __exports__